// frontend/src/pdfWorkerSetup.ts
import { pdfjs } from "react-pdf";

// Use worker from public folder for both development and production
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

console.info("PDF worker set to:", pdfjs.GlobalWorkerOptions.workerSrc);
